module.exports = __webpack_public_path__ + "media/img/frontend_application/nouser_placeholder-59fdc44427d22a9e3a3e6e77b526bf71.svg";